// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
// eslint-disable-next-line import/no-extraneous-dependencies
import CryptoJS from 'crypto-js';
import { type RouterHistory, withRouter, type ContextRouter, Redirect } from 'react-router-dom';
import { AuthActions, BaseActions, CartActions, WishActions, OrdersActions, UserActions } from "store/actionCreators";
import LoginForm from 'components/auth/LoginForm';
import ForgotForm from 'components/auth/ForgotForm';
import { pressedEnter } from 'lib/common';
import type { AuthResult, SocialAuthResult, VerifySocialResult } from 'store/modules/auth';
import type { UserData } from 'store/modules/user';
import type { Cart } from 'store/modules/cart';
import queryString from 'query-string';
import storage, {keys} from "../../lib/storage";

type Props = {
  user: ?UserData,
  email: string,
  sentEmail: boolean,
  sending: boolean,
  retry: boolean,
  isUser: boolean,
  socialAuthResult: SocialAuthResult,
  verifySocialResult: VerifySocialResult,
  authResult: AuthResult,
  history: RouterHistory,
  nextUrl: ?string,
  typeName: string,
  cart: Cart,
} & ContextRouter;

type State = {
  isEmailVerified: boolean,
  isEmailCapitalized: boolean,
  isNonRegisteredOrder: boolean,
};

class AuthFormContainer extends Component<Props, State> {
  state = {
    isEmailVerified: true,
    isEmailCapitalized: false,
    isNonRegisteredOrder: false,
  };

  onNonRegisteredOrderToggle = () => {
    this.setState({
      isNonRegisteredOrder: !this.state.isNonRegisteredOrder,
    });
  };

  onChangeEmail = (e: SyntheticInputEvent<HTMLInputElement>) => {
    const { value } = e.target;
    AuthActions.setEmailInput(value);
  };

  onChangePassword = (e: SyntheticInputEvent<HTMLInputElement>) => {
    const { value } = e.target;
    AuthActions.setPasswordInput(value);
  };

  onChangeOrderId = (e: SyntheticInputEvent<HTMLInputElement>) => {
    const { value } = e.target;
    AuthActions.setOrderIdInput(value);
  };

  checkEmail = () => {
    const { email } = this.props;

    if (email) {
      // const regExpEmail = /^[0-9a-z]([-_.]?[0-9a-z])*@[0-9a-z]([-_.]?[0-9a-z])*\.[a-z]{2,}$/;
      const regExpCapital = /.*[A-Z].*/;

      this.setState({ isEmailCapitalized: regExpCapital.test(email) });
      // this.setState({ isEmailVerified: regExpEmail.test(email) });

      if (regExpCapital.test(email)) {
        return false;
      }

      // if (regExpEmail.test(email)) {
      //   return true;
      // }

      return true;
    }
    // 입력한 것이 없는 경우
    return false;
  };

  onSendVerification = async (): Promise<*> => {
    const { email, password, typeName, location, history } = this.props;
    const { next } = queryString.parse(location.search);

    if (this.checkEmail()) {
      try {
        if (typeName === '비밀번호 재설정') {
          await AuthActions.sendAuthEmail({ email, next });
          history.push('/login');
          BaseActions.showToast({
            type: 'success',
            message: '비밀번호 재설정 안내 메일을 보냈습니다.',
          });
        } else {
          const authResult = await AuthActions.emailLogin({ email, password, next });
          const { user } = authResult.data;
          const localCart = Object.assign({}, this.props.cart);
          await UserActions.setUser(user);
          let phone = '';
          if (user.mobile) {
            const cleanNumber = user.mobile.replace(/-/g, '');
            phone = `+82${cleanNumber}`;
            const e164Regex = /^\+[1-9]\d{1,14}$/;
            if (!e164Regex.test(phone)) {
              console.warn('전화번호가 E.164 형식에 맞지 않습니다:', phone);
              phone = '';
            }
          }
          const hash = CryptoJS.HmacSHA256(`${user.id}`, '208b18c115cae1b2f8f3528057362fd8e8506fb5').toString()
          window.Tawk_API.login({
            hash,
            userId: user.id,
            name: user.managerName || '',
            email: user.email,
            phone,
            companyName: user.displayName || '',
            bizNumber: user.bizNumber || '',
            grade: user.grade ? user.grade.name : '',
          }, (error) => {
            if (error) {
              console.error('Tawk API 로그인 오류:', error);
            } else {
              console.log('Tawk API 로그인 성공');
            }
          });

          const list = [];
          const count = localCart.items.length;
          // eslint-disable-next-line no-restricted-syntax
          for (const item of localCart.items) {
            const index = localCart.items.indexOf(item);
            // eslint-disable-next-line no-await-in-loop
            await CartActions.addItemCart({
              productId: item.product.id,
              productPriceId: item.product_price.id,
              quantity: item.quantity,
            });
            if (item.checked) {
              list.push(index)
            }
          }

          await CartActions.getCart();
          await WishActions.getWish();

          // eslint-disable-next-line no-restricted-syntax
          for (const item of this.props.cart.items) {
            const index = this.props.cart.items.indexOf(item);
            const len = this.props.cart.items.length - count;
            const lenList = list.map(idx => idx + len);
            if (!lenList.includes(index)) {
              // eslint-disable-next-line no-await-in-loop
              CartActions.updateCheckedCart(index);
            }
          }
          window.CacheBy.LocalCart.empty();
          storage.set(keys.user, user);
          const historyPath = next || '/';
          history.push(historyPath);
        }
      } catch (e) {
        console.log(e);
        BaseActions.showToast({
          type: 'error',
          message: e.response.data.message,
        });
      }
    }
  };

  onSendOrderId = async (): Promise<*> => {
    const { orderId, location, history } = this.props;
    await history.push(`/orders/${orderId}`);
    await AuthActions.setOrderIdInput('');
  };

  onEnterKeyPress = pressedEnter(() => {
    this.onSendVerification();
  });

  onReTryVerification = async (): Promise<*> => {
    try {
      await AuthActions.retryAuthEmail();
    } catch (e) {
      console.log(e);
    }
  };

  onSocialLogin = async (provider: string) => {
    const nextUrl = this.props.nextUrl || '/';
    if (provider === 'google') {
      const googleLoginUrl = `${process.env.API_URL || ''}/auth/callback/google/login?next=${nextUrl}`;
      window.location.replace(googleLoginUrl);
      return;
    }
    if (provider === 'facebook') {
      const facebookLogin = `${process.env.API_URL || ''}/auth/callback/facebook/login?next=${nextUrl}`;
      window.location.replace(facebookLogin);
    }
    if (provider === 'naver') {
      const naverLogin = `${process.env.API_URL || ''}/auth/callback/naver/login?next=${nextUrl}`;
      window.location.replace(naverLogin);
    }
  };

  componentDidMount() {
    const { location } = this.props;
    const query = queryString.parse(location.search);
    if (query.next) {
      AuthActions.setNextUrl(query.next);
    }
  }

  render() {
    const {
      onChangeEmail,
      onChangePassword,
      onChangeOrderId,
      onSendVerification,
      onSendOrderId,
      onReTryVerification,
      onEnterKeyPress,
      onSocialLogin,
      onNonRegisteredOrderToggle,
    } = this;
    const { email, password, orderId, sentEmail, sending, retry, isUser, typeName, user, logged, nextUrl } = this.props;

    if (typeName === '비밀번호 재설정') {
      return (
        <ForgotForm
          isUser={isUser}
          email={email}
          sending={sending}
          retry={retry}
          sentEmail={sentEmail}
          onChangeEmail={onChangeEmail}
          onSendVerification={onSendVerification}
          onReTryVerification={onReTryVerification}
          onEnterKeyPress={onEnterKeyPress}
          typeName={typeName}
          isEmailVerified={this.state.isEmailVerified}
          isEmailCapitalized={this.state.isEmailCapitalized}
        />
      );
    }
    return (
      <LoginForm
        isUser={isUser}
        email={email}
        password={password}
        orderId={orderId}
        sending={sending}
        retry={retry}
        sentEmail={sentEmail}
        onChangeEmail={onChangeEmail}
        onChangePassword={onChangePassword}
        onChangeOrderId={onChangeOrderId}
        onSendVerification={onSendVerification}
        onSendOrderId={onSendOrderId}
        onReTryVerification={onReTryVerification}
        onNonRegisteredOrderToggle={onNonRegisteredOrderToggle}
        onEnterKeyPress={onEnterKeyPress}
        typeName={typeName}
        onSocialLogin={onSocialLogin}
        isEmailVerified={this.state.isEmailVerified}
        isEmailCapitalized={this.state.isEmailCapitalized}
        isNonRegisteredOrder={this.state.isNonRegisteredOrder}
        logged={logged}
        nextUrl={nextUrl}
        location={this.props.location}
      />
    );
  }
}

export default connect(
  ({ auth, cart, pender, user }) => ({
    email: auth.email,
    password: auth.password,
    orderId: auth.orderId,
    sentEmail: auth.sentEmail,
    isUser: auth.isUser,
    sending: pender.pending['auth/EMAIL_LOGIN'],
    socialAuthResult: auth.socialAuthResult,
    verifySocialResult: auth.verifySocialResult,
    authResult: auth.authResult,
    nextUrl: auth.nextUrl,
    user: user.user,
    logged: !!user.user,
    cart,
  }),
  () => ({}),
)(withRouter(AuthFormContainer));



// WEBPACK FOOTER //
// ./src/containers/auth/AuthFormContainer.js